<template>
    <input 
        ref="input" 
        type="text" 
        class="form-control" 
        v-model="valueModel"
        @blur="tryParseValue()"
    />
</template>

<script>

import { secondsToJiraTimeString as timeString, toSeconds, timeUnit } from '../../../Util/time';

const jiraPattern = /(\d+(?:\.\d+)?)([mh])/g;
const numbersOnlyPattern = /^(\d+(?:\.\d+)?)[ ]*$/;

export default {
    name: 'sprint-planning-timeupdate',
    created() {
        this.valueModel = timeString(this.value);
    },
    methods: {
        tryParseValue() {
            const value = this.$refs.input.value.replace(',','.');
            let match = numbersOnlyPattern.exec(value);
            let seconds = null;

            //Assume hours
            if(match) {
                seconds = toSeconds(match[1], timeUnit.hour);
            } else {
                do {
                    match = jiraPattern.exec(value);
                    if(match) {
                        seconds += toSeconds(match[1], match[2]);
                    }
                } while (match);
            }

            if(seconds !== null) {
                this.$emit('input', seconds);
            }
        }
    },
    data() {
        return {
            valueModel: null,
            invalid: false
        };
    },
    watch: {
        value(value) {
            this.valueModel = timeString(value);
        }
    },
    props: {
        value: {
            type: Number,
            default: null
        }
    }
};
</script>

<style lang="scss" scoped>

</style>